import { DataTable } from "@/shared/components/table";
import { DataTableToolbar } from "@/shared/components/table/DataTableToolbar";
import { Button } from "@/shared/components/ui/button";
import { RotateCw } from "lucide-react";
import { useEffect } from "react";
import { useControlPanelUserColumns } from "../hooks/useControlPanelUserColumns";
import { useControlPanelUsers } from "../hooks/useControlPanelUsers";
import { ControlPanelUserDialog } from "./ControlPanelUserDialog";

export function UserTable({ canWrite }: { canWrite: boolean }) {
  const vm = useControlPanelUsers();
  const { load } = vm;
  const columns = useControlPanelUserColumns();

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="space-y-4">
      <DataTable
        columns={columns}
        data={vm.rows}
        totalCount={vm.rows.length}
        page={1}
        pageSize={50}
        isLoading={vm.isLoading}
        enableRowSelection
        rowSelectionTrigger="checkbox"
        getRowId={(r) => String(r.id)}
        onRowSelectionChange={(selected) => vm.setSelectedUserIds(selected.map((r) => r.id))}
        onRowClick={canWrite ? (row) => vm.openEditByRow(row) : undefined}
        toolbar={
          <DataTableToolbar
            filters={
              <div className="text-sm text-muted-foreground">
                {vm.summary.selected > 0 && (
                  <>
                    {" · "}선택{" "}
                    <span className="font-medium text-foreground">{vm.summary.selected}</span>명
                  </>
                )}
              </div>
            }
            actions={
              <>
                <Button variant="outline" onClick={vm.load}>
                  <RotateCw className="mr-2 h-4 w-4" />
                  새로고침
                </Button>
                <Button onClick={vm.openAdd} disabled={!canWrite}>
                  추가
                </Button>
                <Button
                  variant="destructive"
                  onClick={vm.deleteSelected}
                  disabled={!canWrite || vm.summary.selected === 0}
                >
                  삭제
                </Button>
              </>
            }
          />
        }
      />

      <ControlPanelUserDialog
        open={vm.modalOpen}
        mode={vm.modalMode}
        grantGroups={vm.allGrantGroups}
        value={vm.form}
        onChange={vm.setForm}
        onToggleGroup={vm.toggleGrantGroup}
        onCancel={vm.closeModal}
        onSubmit={vm.submit}
      />
    </div>
  );
}
